import { css } from "../../../../../../styles";

export const TooltipCss = css({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",

  p: {
    fontSize: "14px",
    fontWeight: 500,
    fontFamily: "$openSans",
    margin: "2px 0",
  },
});
